<script>
import Habitacion from "./Habitacion";

export default {
  name: "Habitaciones",
  components: { Habitacion },
  props: {
    value: { type: Array, required: true },
  },
};
</script>

<template>
  <div>
    <table class="table table-condensed">
      <tbody>
        <Habitacion
          v-for="(habitacion, habKey) in value"
          :key="habitacion.base + habitacion.numero"
          v-model="value[habKey]"
        />
      </tbody>
    </table>
    <div class="panel-footer clearfix">
      <div class="pull-left">
        Habitaciones: <b>{{ value.length }}</b> / Pasajeros:
        <b>{{
          value
            .map((h) => h.pasajeros.length)
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            )
        }}</b>
      </div>
    </div>
  </div>
</template>

<style scoped>
table {
  margin-bottom: 0;
}
</style>